import React, { useEffect } from "react"
import { Form, Select, Input } from "antd"
import InputField from "../../components/Common/InputField"
import { productCategories } from "../../utils/constants"
import { translations } from "../../utils/Translation/staticTranslation"

const ProductFormItem = ({ form, formItem, product, className }) => {
  useEffect(() => {
    if (product) {
      form.setFieldsValue({
        [`product_name_${formItem.id}`]: product.name_english || "",
        [`category_${formItem.id}`]: product.category || undefined,
        [`price_unit_${formItem.id}`]: product.price_unit || "",
        [`price_amount_${formItem.id}`]: product.price_amount || "",
        [`image_url_${formItem.id}`]: product.image_url || "",
        [`product_url_${formItem.id}`]: product.product_url || "",
      })
    }
  }, [product, form, formItem.id])

  const lang = localStorage.getItem("language") || "ar"
  const addManualPage = translations[lang]?.productPage?.add_manual_page

  return (
    <div className={` mb-22 ${className}`}>
      <p className="text-16 font-700 text-141414 mb-28">
        {addManualPage?.details}
      </p>

      <div className="row">
        <InputField
          label={addManualPage?.product_name}
          className="store-field store-form-placeholder"
          formclass="col-6"
          name={`product_name_${formItem.id}`}
          placeholder={addManualPage?.product_placeholder}
          rules={[
            { required: true, message: addManualPage?.product_name_error },
          ]}
          // suffix={
          //   <Tooltip title="Extra information">
          //     <InfoCircleOutlined />
          //   </Tooltip>
          // }
        />
        <Form.Item
          className="col-6 error-input-fix"
          label={addManualPage?.select_type}
          name={`category_${formItem.id}`}
          rules={[
            { required: true, message: addManualPage?.select_type_error },
          ]}
        >
          <Select
            showSearch
            optionFilterProp="label"
            placeholder={addManualPage?.select_type_placeholder}
            className="store-select"
            options={productCategories.map((item) => ({
              value: item.value,
              label: lang === "ar" ? item.label_ar : item.label_en,
            }))}
          />
        </Form.Item>
      </div>

      <div className="row">
        <InputField
          label={addManualPage?.product_unit}
          className="store-field store-form-placeholder"
          formclass="col-6"
          name={`price_unit_${formItem.id}`}
          placeholder={addManualPage?.product_unit_placeholder}
          rules={[
            { required: true, message: addManualPage?.product_unit_error },
          ]}
          // suffix={
          //   <Tooltip title='Extra information'>
          //     <InfoCircleOutlined />
          //   </Tooltip>
          // }
        />
        <Form.Item
          className="col-6"
          label={addManualPage?.product_price}
          name={`price_amount_${formItem.id}`}
          rules={[
            { required: true, message: addManualPage?.product_price_error_1 },
            {
              validator: (_, value) =>
                value && value > 0
                  ? Promise.resolve()
                  : Promise.reject(addManualPage?.product_price_error_2),
            },
          ]}
        >
          <Input
            type="number"
            min={1}
            placeholder={addManualPage?.product_price_placeholder}
            className="store-field store-form-placeholder"
            // suffix={
            //   <Tooltip title='Extra information'>
            //     <InfoCircleOutlined />
            //   </Tooltip>
            // }
          />
        </Form.Item>
      </div>

      <div className="row">
        <InputField
          label={addManualPage?.image_url}
          className="store-field store-form-placeholder"
          formclass="col-6"
          name={`image_url_${formItem.id}`}
          type="url"
          placeholder={addManualPage?.image_url_placeholder}
          rules={[
            { type: "url", message: addManualPage?.image_url_error_2 },
            { required: true, message: addManualPage?.image_url_error_1 },
          ]}
          // suffix={<LinkOutlined />}
        />
        <InputField
          label={addManualPage?.product_url}
          className="store-field store-form-placeholder"
          formclass="col-6"
          name={`product_url_${formItem.id}`}
          type="url"
          placeholder={addManualPage?.product_url_placeholder}
          rules={[
            { type: "url", message: addManualPage?.product_url_error_2 },
            { required: true, message: addManualPage?.product_url_error_1 },
          ]}
          // suffix={<LinkOutlined />}
        />
      </div>
    </div>
  )
}

export default ProductFormItem
